/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Container, Breadcrumb, BreadcrumbItem, Button, Row, Col, Label, Card, CardTitle, Dropdown, CardText, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import cemetery from '../../../../assets/icon_cemetery.png';
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { IoCallOutline } from 'react-icons/io5';
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { BiExitFullscreen, BiDotsVerticalRounded } from "react-icons/bi";
import ShareModal from '../../../../components/Modals/ShareModal';
import ReportSuggestionModal from '../../../../components/Modals/ReportSuggestionModal';
import CreateNewRouteModal from '../../../../components/Modals/CreateNewRouteModal';
import SelectRouteModal from '../../../../components/Modals/SelectRouteModal';
import PointsListingModal from '../../../../components/Modals/PointsListingModal';
import { tzadikimDetail } from '../../../../services/category.service';
import { addUserFavorite, removeUserFavorite } from '../../../../services/favourites.service';
import './Detail.scss';
import { MdLocationOn } from "react-icons/md";
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { routeDetail, updateRouteDetail } from '../../../../services/myRoute.service';
import marked_pop from "../../../../assets/marked_pop.svg";

const containerStyle = {
    width: '100%',
    height: '320px'
};

const options = {
    minZoom: 2,
    maxZoom: 17,
    gestureHandling: 'greedy'
}

function TzadikimShareLink({ isUserLoggedIn }) {
    const location = useLocation()
    const { from } = location?.state || '';
    const [dropdownMenuOpen, setMenuOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);
    const [route, setRoute] = useState(null);
    const [routeName, setRouteName] = useState(null);
    const [pointName, setPointName] = useState(null);
    const [place, setPlace] = useState([]);
    const [checkForFavorite, setCheckForFavorite] = useState(null);
    const [mkmID, setMkmId] = useState();
    const [activeMarker, setActiveMarker] = useState(null);
    const [link, setLink] = useState('');
    const [showSpinner, setShowSpinner] = useState(false);

    const toggle = () => {
        setShowModal(!showModal);
        setRoute(null);
    };

    const email = useSelector((state) => state?.userDetailReducer?.userData?.email);
    const userName = useSelector((state) => state?.userDetailReducer?.userData?.userName);
    const navigate = useNavigate();

    let { id } = useParams();
    let { poi } = useParams();
    var detailPoi = poi?.split(",");

    const center = {
        lat: Number(detailPoi[0]),
        lng: Number(detailPoi[1]),
    };

    useEffect(() => {
        setTimeout(() => {
            window?.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0)
    }, []);

    useEffect(() => {
        tzadikimPlaceDetail()
    }, [place?.cityE]);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8"
    });

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const share = () => {
        setLink(window.location.href)
        setShowShareModal(true);
    }

    const tzadikimPlaceDetail = async () => {
        try {
            let obj = {
                tzadikimID: id,
                email: email,
                checkForFavorite: true
            }
            let response = await tzadikimDetail(obj);
            if (response && response?.status === 200) {
                setPlace(response?.data?.data);
            }

        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
                {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000,
                }
            );
        }
    }

    const createNewRoute = () => {
        setShowModal(false);
        setShowCreateRouteModal(true);
    };

    const addToRoute = (id) => {
        setMkmId(id)
        setShowModal(true);
    };


    const reportSuggestion = (title, id) => {
        setMkmId(id)
        setPointName(title)
        setShowReportModal(true);
    }

    const NavigateClick = () => {
        const url = `https://www.google.com/maps/search/?api=1&query=${place?.poi}`
        window.open(url, '_blank');
    }

    const selectRoute = async () => {
        let existingData;
        if (route?.id) {
            try {
                let response = await routeDetail({
                    userName: userName,
                    routeID: route?.id
                });
                if (response && response?.status === 200) {
                    existingData = response?.data?.data
                }

                let requestBody = [];
                if (existingData?.length < 25) {
                    if (existingData?.length === 0) {
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                    } else if (existingData?.length === 1) {
                        requestBody?.push({
                            mkmID: existingData[0]?.place?.mkmID,
                            orderNumber: 0,
                            visited: false
                        });
                        requestBody?.push({
                            mkmID: mkmID,
                            orderNumber: 1,
                            visited: false
                        })
                    } else {
                        existingData?.splice(existingData?.length, 0, {
                            mkmID: mkmID,
                            orderNumber: existingData?.length,
                            visited: false
                        });
                        requestBody = existingData?.map((item, i) => {
                            return {
                                mkmID: item?.place?.mkmID || item?.mkmID,
                                orderNumber: i,
                                visited: item?.visited
                            }
                        });
                    }
                    try {
                        setShowSpinner(true);
                        let res = await updateRouteDetail(requestBody, {
                            userName: userName,
                            routeID: route?.id,
                        });
                        if (res && res?.status === 200) {
                            toast.success("Point Added Successfully In Your Route!", {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000
                            })
                            setShowSpinner(false);
                        }
                    } catch (err) {
                        toast.error(
                            err?.response?.data?.message ||
                            "Oops.. something went wrong, try again !!!",
                            {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 2000,
                            }
                        );
                        setShowSpinner(false);
                    }
                    setRoute('');
                    setShowModal(false);
                }
                else {
                    toast.warning("Max of only 25 points can be added to a route, Kindly remove a point to add a new point.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    })
                    setShowSpinner(false);
                }
            } catch (error) {
                console.log(error)
                setShowSpinner(false);
            };
        }
        if (!route?.id) {
            toast.error("Please Select The Route.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            })
            setShowSpinner(false);
        }
    }


    const addToFavorite = async (id, fav) => {
        if (isUserLoggedIn) {
            const willFavorite = await swal({
                title: "Are you sure?",
                text: "You want to add this route in Favorites?",
                icon: marked_pop,
                buttons: true,
            }).then(async () => {
                try {
                    const obj = {
                        userName: userName
                    }
                    const data = {
                        mkmId: null,
                        tzId: id?.tzadikimID
                    }
                    const response = await addUserFavorite(data, obj)
                    setCheckForFavorite(fav);
                    if (response && response?.status === 200) {
                        swal("Added!", "Your route has been added in Favorites!", "success");
                        tzadikimPlaceDetail()
                    }

                } catch (error) {
                    toast.error(
                        error?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            });
            if (willFavorite) {
                swal("Added!", "Your route has been added in Favorites!", "success");
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to add this route in Favorites?",
                icon: marked_pop,
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    const removeFromFavorite = async (id, fav) => {
        if (isUserLoggedIn) {
            const willRemoveFavorite = await swal({
                title: "Are you sure?",
                text: "You want to remove this route from Favorites?",
                icon: marked_pop,
                buttons: true,
            }).then(async () => {
                try {
                    const obj = {
                        userName: userName
                    }
                    const data = {
                        mkmId: null,
                        tzId: id?.tzadikimID
                    }
                    const response = await removeUserFavorite(data, obj)
                    setCheckForFavorite(fav);
                    if (response && response?.status === 200) {
                        swal("Removed!", "Your route has been removed from Favorites!", "success");
                        tzadikimPlaceDetail()
                    }
                } catch (error) {
                    toast.error(
                        error?.response?.data?.message ||
                        "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                }
            })
            if (willRemoveFavorite) {
                swal("Removed!", "Your route has been removed from Favorites!", "success");
            }
        }
        else {
            const notLoggedIn = await swal({
                title: "Please Continue to Log In",
                text: "You want to remove this route from Favorites?",
                icon: marked_pop,
                buttons: ["Cancel", "Log In"],
            })
            if (notLoggedIn) {
                navigate('/sign-in');
            }
        }
    }

    return (
        <div className='main_section cemetery_detail'>
            <Container>
            <SelectRouteModal
                route={route}
                setRoute={setRoute}
                showModal={showModal}
                toggle={toggle}
                createNewRoute={createNewRoute}
                selectRoute={selectRoute}
                showSpinner={showSpinner}
            />
            <CreateNewRouteModal
                showCreateRouteModal={showCreateRouteModal}
                setShowCreateRouteModal={setShowCreateRouteModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                routeName={routeName}
                setRouteName={setRouteName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <PointsListingModal
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <ReportSuggestionModal
                showReportModal={showReportModal}
                setShowReportModal={setShowReportModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                mkmID={mkmID}
            />
            <ShareModal
                showShareModal={showShareModal}
                setShowShareModal={setShowShareModal}
                link={link}
                setLink={setLink}
            />
            {/* <SearchBar /> */}
            <div className='breadcrumb_section'>
                <Container >
                    <Breadcrumb className="breadcrumb">
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to="/" className="breadcrumb_item1">Category</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to="/category-list" className="breadcrumb_item1" state={{ from: "Tzadikim" }}>Tzadikim</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active className="breadcrumb_item2">Details</BreadcrumbItem>
                    </Breadcrumb>
                </Container>
            </div>
            <div className="details_section">
                <Container fluid>
                    <div className="details_box">
                        <Container>
                            <Row>
                                <Col >
                                    <div className="map">
                                        {isLoaded ? (
                                            <GoogleMap
                                                zoom={12}
                                                mapContainerStyle={containerStyle}
                                                center={center}
                                                options={options}
                                            >
                                                <Marker
                                                    position={{
                                                        lat: Number(detailPoi[0]),
                                                        lng: Number(detailPoi[1]),
                                                    }}
                                                    onClick={() => handleActiveMarker(place?.mkmID)}
                                                    icon={{
                                                        url: place?.categotyID === 1
                                                            ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                                            : place?.categotyID === 10
                                                                ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                                                                : place?.categotyID === 5
                                                                    ? "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"
                                                                    : place?.categotyID === 4
                                                                        ? require('../../../../assets/darkpurple.png')
                                                                        : place?.categotyID === 2
                                                                            ? "http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png"
                                                                            : place?.categotyID === 7
                                                                                ? "http://maps.google.com/mapfiles/ms/icons/pink-dot.png"
                                                                                : place?.categotyID === 9
                                                                                    ? require('../../../../assets/gray.png')
                                                                                    : place?.categotyID === 12
                                                                                        ? require('../../../../assets/darkblue.png')
                                                                                        : require('../../../../assets/lightpink.png')
                                                    }}
                                                >
                                                    {activeMarker === place?.mkmID ? (
                                                        <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                            <div className="info_window"> <Card body>
                                                                <div className="card_header">
                                                                    {place?.userFavorite === true ? <Button className='favourite_fill_icon'
                                                                        onClick={() => removeFromFavorite(place?.mkmID)}
                                                                    ><AiFillStar size={20} /></Button> :
                                                                        <Button className="favourite_icon"
                                                                            onClick={() => addToFavorite(place?.mkmID)}
                                                                        ><AiOutlineStar size={20} /></Button>
                                                                    }
                                                                    <div className="right_section">
                                                                        <CardTitle tag="h5" title={place?.title}>{place?.title}</CardTitle>
                                                                        <Dropdown className="moreInfo" toggle={() => { setMenuOpen(!dropdownMenuOpen) }}
                                                                            isOpen={dropdownMenuOpen}
                                                                        >
                                                                            <DropdownToggle>
                                                                                <BiDotsVerticalRounded size={20} />
                                                                            </DropdownToggle>
                                                                            <DropdownMenu>
                                                                                <DropdownItem >
                                                                                    <Link to={`/along-the-way-to-here/${place?.poi}`} className="breadcrumb_item1">Along the way to here</Link>
                                                                                </DropdownItem>
                                                                                <DropdownItem onClick={() => reportSuggestion(place?.title, place?.mkmID)}>
                                                                                    Report suggestion
                                                                                </DropdownItem>
                                                                            </DropdownMenu>
                                                                        </Dropdown>

                                                                    </div>
                                                                </div>
                                                                <CardText className="grid_text_le">{place?.stateY} {place?.cityY}</CardText>
                                                                <div className="card_bottom">
                                                                    <Button onClick={share}><FiShare2 size={20} /></Button>
                                                                    <div className="right_section">
                                                                        <CardText>{place?.cityE + " " + place?.stateE}</CardText>
                                                                        <MdLocationOn className="location_icon" size={18} />
                                                                    </div>
                                                                </div>
                                                                <div className="card_footer">
                                                                    <Link to={`/explore-near-by/${place?.poi}`} className="btn explore"><BiExitFullscreen className="explore_icon" />Explore Near By</Link>
                                                                    {/* <Link to={`/category-detail/${place?.mkmID}/${place?.poi}`} className="btn viewmore">View More</Link> */}
                                                                    <Button className="btn addroute" onClick={() => addToRoute(place?.mkmID)}><FiBriefcase className="addroute_icon" />Add to Route</Button>
                                                                </div>
                                                            </Card></div>
                                                        </InfoWindow>
                                                    ) : null}
                                                </Marker>
                                            </GoogleMap>
                                        ) : <></>}
                                    </div>
                                    <div className='map_footer'>
                                        <div className='map_footer_left'>
                                            <img src={cemetery} alt="cemetery" className="cemetery_icon" />
                                            <Label>Tzadikim / {place?.title}</Label>

                                            <div className='icons'>
                                                {place?.userFavorite === true ? <Button
                                                    onClick={() => removeFromFavorite({ tzadikimID: place?.tzadikimID }, place?.userFavorite)}
                                                > <AiFillStar size={25} className='favourite_fill_icon' /> </Button> :
                                                    <Button
                                                        onClick={() => addToFavorite({ tzadikimID: place?.tzadikimID }, place?.userFavorite)}
                                                    ><AiOutlineStar size={25} className="link_favourite" /></Button>}

                                                <Button onClick={share}>
                                                    <FiShare2 size={25} className='share' />
                                                </Button>
                                            </div>

                                        </div>
                                        <div className='map_footer_right'>
                                            <Button onClick={() => reportSuggestion(place?.title, place?.tzadikimID)}>
                                                Report Suggestion
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row xs="2">
                                <Col lg="12" md="12" xs="12" >
                                    <div className='detail_section'>
                                        <div className='details_left'>
                                            <h4>{place?.title}</h4>
                                            <ul>
                                                <li>{place?.nfInfo ? place?.nfInfo : place?.stateY + ' ' + place?.cityY}</li>
                                            </ul>
                                            <p className='location'>
                                                {place?.streetNumber} {place?.streetName}
                                            </p>
                                            <p className='location'>
                                                {place?.cityE}, {place?.stateE}
                                            </p>
                                            <p>
                                                {place?.poi}
                                            </p>
                                            <div className='contact'>
                                                <IoCallOutline size={25} className="contact_icon" />
                                                <Label className='contact_number'>N/A</Label>
                                            </div>
                                        </div>
                                        <div className='detai_button'>
                                            <div className='buttons'>
                                                <Button onClick={NavigateClick}><BiExitFullscreen />
                                                    Navigate
                                                </Button>
                                                <Button onClick={() => addToRoute(place?.mkmID)}><FiBriefcase />
                                                    Add to Route
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg="12" md="12" xs="12">
                                    <div className='tzk_detail'>
                                        <h3>{place?.subTitle}</h3>
                                        <p>{place?.tfilis}</p>

                                    </div>
                                </Col>

                            </Row>
                            <Row xs="2">
                                <Col lg="12" md="12" xs="12">
                                    <div className='tzk_detail'>
                                        <h3>header 1</h3>
                                        <p>{place?.toldes}</p> </div>
                                </Col>

                                {place?.mchs ? <Col lg="12" md="12" xs="12">
                                    <div className='tzk_detail'>
                                        <h3>header 2</h3>
                                        <p>{place?.mchs}</p></div>
                                </Col> : null}
                            </Row>
                        </Container>
                    </div>
                </Container>
            </div>
            </Container>
        </div>
    )
}

export default TzadikimShareLink